import { LinearProgress, Stack, Typography } from '@mui/material';
import type { KpiId } from '@serb/shared';
import { KpiTarget } from './KpiTarget';

type Props = {
  label: string;
  /** 0–100, or null while there is no data (the bar is greyed and says "No data yet") */
  value: number | null;
  tone: 'success' | 'primary' | 'info' | 'warning' | 'error';
  /** text to show instead of "NN%", for example "5.2 days" */
  text?: string;
  /** the KPI whose acceptable rate (from Settings) is shown under the bar */
  kpi?: KpiId;
};

/** One line of a performance panel: label, bar, and the number (or "No data yet") */
export function PerformanceBar({ label, value, tone, text, kpi }: Props) {
  return (
    <Stack spacing={0.25}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
        <Typography variant="body2" sx={{ width: 130, flexShrink: 0 }}>
          {label}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={value ?? 0}
          color={tone}
          sx={{ flex: 1, height: 10, borderRadius: 5, opacity: value === null ? 0.35 : 1 }}
        />
        <Typography
          variant="body2"
          color={value === null ? 'text.secondary' : 'text.primary'}
          sx={{ width: 76, textAlign: 'right', fontWeight: value === null ? 400 : 700 }}
        >
          {value === null ? 'No data yet' : (text ?? `${value}%`)}
        </Typography>
      </Stack>
      {kpi && (
        <Stack sx={{ pl: '142px', alignItems: 'flex-start' }}>
          <KpiTarget id={kpi} actual={value} />
        </Stack>
      )}
    </Stack>
  );
}
